import { Dialog, Portal, Spinner, createOverlay } from "@chakra-ui/react";

export const spinnerOverlay = createOverlay((props) => {
  return (
    <Dialog.Root {...props} placement="center">
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Spinner size="xl" />
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
});
